var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YouTube"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8303 20.5C12.6795 20.4627 10.7291 20.4627 8.74694 20.3788C7.25895 20.3311 5.77443 20.2036 4.29951 19.9967C2.41755 19.7078 1.29202 18.4356 1.00039 16.497C0.68469 14.1601 0.568813 11.7994 0.65407 9.44179C0.65407 8.21621 0.745206 6.9813 0.836342 5.75572C0.883113 5.08388 0.989883 4.41783 1.15532 3.76589C1.317 3.034 1.69731 2.37167 2.24353 1.87069C2.78974 1.36971 3.47482 1.0549 4.20381 0.969885C5.6259 0.743216 7.06177 0.618644 8.50087 0.597084C11.7089 0.519417 14.9168 0.48835 18.1248 0.503883C20.0797 0.503883 22.0346 0.666984 23.9849 0.774164C24.5025 0.806741 25.0172 0.876817 25.5251 0.983865C26.243 1.09723 26.9074 1.44007 27.4231 1.96325C27.9388 2.48644 28.2793 3.16313 28.3958 3.89637C28.6702 5.37029 28.8227 6.86523 28.8515 8.36533C28.9852 10.873 28.9074 13.3879 28.6191 15.8819C28.5686 16.3298 28.4879 16.7735 28.3776 17.21C28.2158 17.9386 27.8378 18.5982 27.2954 19.0987C26.753 19.5992 26.0726 19.9161 25.3474 20.006C23.9143 20.2181 22.4704 20.3442 21.023 20.3835C18.8813 20.4441 16.7715 20.4581 14.8303 20.5ZM12.078 14.9499L19.1638 10.4856L12.078 6.01202V14.9499Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.6d4c13e5.svg";
export { ForwardRef as ReactComponent };